export default "__VITE_ASSET__BHI7SySW__"